import { useEffect, useRef, useState } from "react";
import ListDisplay from "../components/listDisplay/listDisplay";
import "./employees.css";
import useMyFetch from "../components/fetch/fetch";
import PopupBox from "../components/popup/popup";
import { DropDownBox2, InputBox2 } from "../components/inputBox/inputBox";
import toast from "react-hot-toast";
import { useData } from "../components/dataProvider/dataProvider";

const Employees = () => {
  const { post } = useMyFetch();
  const [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState({
    newEmployee: false,
    editEmployee: false,
    deleteEmployee: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    post("employee").then((response) => {
      if (response.status !== "success") {
        toast.error(response.message);
        return;
      }
      if (Array.isArray(response.data)) {
        setData(response.data);
        setLoading(false);
      } else {
        const dataArray = Object.keys(response.data).map((key) => data[key]);
        setData(dataArray);
      }
    });
  }, []);
  const [id, setId] = useState(0);
  const [name, setName] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(1);
  const { setLoadingScreen } = useData();
  // const [newPassword, setNewPassword] = useState(1);

  const nameInput = useRef(null);
  const userNameInput = useRef(null);
  const passwordInput = useRef(null);

  function KeyPressHandler(event, nextRef, isLast = false) {
    if (event.key === "Enter") {
      event.preventDefault();
      if (event.target.value !== "") {
        if (isLast) {
          if (showPopup.editEmployee) {
            confirmEdit();
            return;
          }
          ConfirmNewEmployee();
        }
        if (nextRef && nextRef.current) {
          nextRef.current.focus();
        }
      }
    }
  }

  const inputCheck = () => {
    if (name === "") {
      toast.error("Employee's Name Cannot be Empty");
      nameInput.current.focus();
      return false;
    }
    if (userName === "") {
      toast.error("UserName Cannot be Empty");
      userNameInput.current.focus();
      return false;
    }
    if (password === "") {
      toast.error("Password Cannot be Empty");
      passwordInput.current.focus();
      return false;
    }
    if (password.length < 8) {
      toast.error("Password has to be at lease 8 letters long");
      passwordInput.current.focus();
      return false;
    }
    return true;
  };

  const newEmployee = () => {
    console.log("new Employee");
    // setNewPassword(1);
    setName("");
    setUserName("");
    setPassword("");
    setRole(1);
    setShowPopup({ ...showPopup, newEmployee: true });
  };
  const ConfirmNewEmployee = () => {
    if (!inputCheck()) return;
    console.log("Confirm new Employee");
    setLoadingScreen(true);
    post("employee/add", { name, username: userName, password, role }).then((response) => {
      setLoadingScreen(false);
      if (response.status !== "success") {
        toast.error(response.message);
        if (response.message === "Username Already Exist") userNameInput.current.focus();
        return;
      }
      setData([...data, response.data]);
      setShowPopup({ ...showPopup, newEmployee: false });
    });
  };

  const handleEdit = (id) => {
    console.log("Edit action triggered for ID:", id);
    setId(id);
    const employee = data.filter((item) => item.id === id)[0];
    console.log(employee);
    setName(employee.name);
    setUserName(employee.username);
    setPassword(employee.password);
    setRole(employee.role);
    // setNewPassword(0);
    setShowPopup({ ...showPopup, editEmployee: true });
  };
  const confirmEdit = () => {
    if (!inputCheck()) return;
    console.log("confirm Edit");
    setLoadingScreen(true);
    post("employee/edit", { id, name, username: userName, password, role }).then((response) => {
      setLoadingScreen(false);
      if (response.status !== "success") {
        toast.error(response.message);
        if (response.message === "Username already exist") userNameInput.current.focus();
        return;
      }
      setData(data.map((item) => (item.id === id ? response.data : item)));
      setShowPopup({ ...showPopup, editEmployee: false });
    });
  };

  const handleDelete = (id) => {
    console.log("Delete action triggered for", id);
    setId(id);
    setShowPopup({ ...showPopup, deleteEmployee: true });
  };
  const ConfirmDeleteEmployee = () => {
    console.log("Confirm Delete Trigger for", id);
    setLoadingScreen(true);
    post("employee/delete", { id: id }).then((response) => {
      setLoadingScreen(false);
      if (response.status !== "success") {
        toast.error(response.message);
        return;
      }
      setData(data.filter((item) => item.id !== id));
      setShowPopup({ ...showPopup, deleteEmployee: false });
    });
  };

  return (
    <div className="pages employees">
      <div className="page-title">
        <h2>Employee List</h2>
        <div className="action">
          <button className="secondary" onClick={newEmployee}>
            <svg width="16px">
              <use xlinkHref="#plus-icon" />
            </svg>
            <p>Add Employee</p>
          </button>
        </div>
      </div>

      <ListDisplay
        titleList={["Name", "Username", "Password"]}
        size={["name", "name", "password"]}
        data={data.map((employee) => ({
          id: employee.id,
          Name: employee.name,
          Username: employee.username,
          Password: employee.password,
        }))}
        actions={[
          { type: "edit", handler: handleEdit },
          { type: "delete", handler: handleDelete },
        ]}
        is_loading={loading}
      />

      {(showPopup.editEmployee || showPopup.newEmployee) && (
        <PopupBox
          formName="new-Employee"
          color="primary"
          close={() => setShowPopup({ ...showPopup, newEmployee: false, editEmployee: false })}
          actions={[
            { type: "cancel", name: "Cancel" },
            {
              type: "success",
              name: showPopup.editEmployee ? "Save" : "Create",
              func: showPopup.editEmployee ? confirmEdit : ConfirmNewEmployee,
            },
          ]}
        >
          <h1>{showPopup.newEmployee ? "Add New Employee" : "Edit Employee's Information"}</h1>
          <svg title="employee-icon" width="88px" height="88px">
            <use xlinkHref="#employee-icon" />
          </svg>
          <InputBox2
            type="text"
            name="name"
            display="Name"
            value={name}
            setValue={setName}
            isRequired={true}
            ref={nameInput}
            onKeyPress={(e) => KeyPressHandler(e, userNameInput)}
            placeholder="Enter Employee's Name"
            autoComplete="off"
          />
          <InputBox2
            type="text"
            name="userName"
            display="UserName"
            value={userName}
            setValue={setUserName}
            isRequired={true}
            ref={userNameInput}
            onKeyPress={(e) => KeyPressHandler(e, passwordInput)}
            placeholder="Enter Username"
            autoComplete="off"
          />

          <InputBox2
            type="password"
            name="password"
            display="Password"
            value={password}
            setValue={setPassword}
            isRequired={true}
            isPassword={true}
            ref={passwordInput}
            onKeyPress={(e) => KeyPressHandler(e, null, true)}
            placeholder="Choose A Password"
            autoComplete="off"
          />
          <DropDownBox2
            name="role"
            display="Employee Type"
            value={role}
            setValue={setRole}
            isRequired={true}
          >
            <option value="0">Owner</option>
            <option value="1">Employee</option>
          </DropDownBox2>
        </PopupBox>
      )}
      {showPopup.deleteEmployee && (
        <PopupBox
          formName="delete-Employee row"
          color="danger"
          close={() => setShowPopup({ ...showPopup, deleteEmployee: false })}
          actions={[
            { type: "cancel", name: "Cancel" },
            {
              type: "danger",
              name: "Delete",
              func: ConfirmDeleteEmployee,
            },
          ]}
        >
          <div className="trash-can">
            <svg viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.31258 25.8345C2.31258 27.5489 3.76571 28.9516 5.54175 28.9516H18.4584C20.2345 28.9516 21.6876 27.5489 21.6876 25.8345V7.13172H2.31258V25.8345ZM23.3022 2.45603H17.6511L16.0365 0.897461H7.96362L6.34904 2.45603H0.697998V5.57315H23.3022V2.45603Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="right">
            <h3>Are you sure?</h3>
            <p>
              Do you really want to delete this Employee?
              <br /> This process cannot be undone.
            </p>
          </div>
        </PopupBox>
      )}
    </div>
  );
};

export default Employees;
